import ImagesMainBannerMarchArdbegWebp from '@/public/images/main-banner/march/ardbeg.webp';
import ImagesMainBannerMarchGiveawayBannerWebp from '@/public/images/main-banner/march/giveaway_banner.webp';
import ImagesMainBannerMarchInterviewWebp from '@/public/images/main-banner/march/interview.webp';

export {
  ImagesMainBannerMarchArdbegWebp,
  ImagesMainBannerMarchGiveawayBannerWebp,
  ImagesMainBannerMarchInterviewWebp,
};
